import React, { FC } from 'react';

import { useCartItemsCount } from 'features/cart/hooks/use-cart-items-count';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useServiceModeLive } from 'state/service-mode';

import { SimpleHomePageDesktop } from '../components/simple-home-page/simple-home-page-desktop';
import { SimpleHomePageMobile } from '../components/simple-home-page/simple-home-page-mobile';
import { ISimpleHomePageItemProps } from '../components/simple-home-page/types';

const SimpleHomePage: FC<React.PropsWithChildren<ISimpleHomePageItemProps>> = ({
  item,
  flatListDimensions,
}) => {
  const isMobile = useIsMobileBreakpoint();
  const serviceMode = useServiceModeLive();
  const numberOfItemsInCart = useCartItemsCount();

  return isMobile ? (
    <SimpleHomePageMobile
      flatListDimensions={flatListDimensions}
      item={item}
      serviceMode={serviceMode}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  ) : (
    <SimpleHomePageDesktop
      flatListDimensions={flatListDimensions}
      item={item}
      serviceMode={serviceMode}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  );
};

export default React.memo(SimpleHomePage);
